import { axiosInstance } from 'shared/config/axios';
import { GetUserPreferencesRequest, UpdateUserPreferencesRequest } from 'entities/Preferences/api/types';

export const getUserPreferences: GetUserPreferencesRequest = () => {
	return axiosInstance.get('/users/preferences');
};

export const updateUserPreferences: UpdateUserPreferencesRequest = (data) => {
	return axiosInstance.post('/users/preferences', data);
};
